import React from 'react';
import { FaExclamationTriangle, FaCheckCircle } from 'react-icons/fa';

const InsuranceGapCard = ({ title, icon: Icon, current, required, gap, formatCurrency, color }) => {
  const hasGap = gap > 0;
  const colorClasses = {
    red: 'border-red-500/50 from-red-900/20 to-red-800/20',
    pink: 'border-pink-500/50 from-pink-900/20 to-pink-800/20',
    blue: 'border-blue-500/50 from-blue-900/20 to-blue-800/20'
  };
  const textColors = {
    red: 'text-red-400',
    pink: 'text-pink-400',
    blue: 'text-blue-400'
  };
  
  return (
    <div className={`bg-gradient-to-br ${colorClasses[color]} rounded-lg p-4 border`}>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-2">
          <Icon className={textColors[color]} />
          <span className={`font-medium ${textColors[color]}`}>{title}</span>
        </div>
        {hasGap ? (
          <span className="px-2 py-0.5 bg-yellow-500/20 text-yellow-400 text-xs rounded-full flex items-center">
            <FaExclamationTriangle className="mr-1" size={10} /> Gap
          </span>
        ) : (
          <span className="px-2 py-0.5 bg-green-500/20 text-green-400 text-xs rounded-full flex items-center">
            <FaCheckCircle className="mr-1" size={10} /> Adequate
          </span>
        )}
      </div>
      <div className="grid grid-cols-3 gap-2 text-sm">
        <div>
          <p className="text-gray-400 text-xs">Current</p>
          <p className="text-white font-medium">{formatCurrency(current)}</p>
        </div>
        <div>
          <p className="text-gray-400 text-xs">Required</p>
          <p className="text-white font-medium">{formatCurrency(required)}</p>
        </div>
        <div>
          <p className="text-gray-400 text-xs">Gap</p>
          <p className={`font-bold ${hasGap ? 'text-yellow-400' : 'text-green-400'}`}>
            {hasGap ? formatCurrency(gap) : '₹0'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default InsuranceGapCard;
